class CollapsibleTab extends HTMLElement {
	connectedCallback() {
		const header = this.querySelector('.collapsible-header');
		const content = this.querySelector('.collapsible-content');
		const tab = this.querySelector('.collapsible-tab');
		if (!header || !content) return;

		header.addEventListener('click', () => {
			tab?.classList.toggle('open');
			content.style.display =
				content.style.display === 'block' ? 'none' : 'block';
				if (content.style.display === 'block') {
					content.style.display === 'none';
				}
		});
	}
}

customElements.define('collapsible-tab', CollapsibleTab);
